/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


/* 
*
CUSTOMIZATIONS by TMFL.STUDIO 
*
*/

(function() {
  console.log('CUSTOM JS LOADED');

  document.addEventListener('DOMContentLoaded', () => {

    const observer = new MutationObserver(() => {
      // -------------------
      // Shopify Forms Styling
      // -------------------
      document.querySelectorAll('shopify-forms-embed').forEach(embed => {
        const shadow = embed.shadowRoot;
        if (!shadow || shadow._customized) return;

        const style = document.createElement('style');
        style.textContent = `
          button[type="submit"] {
            box-shadow: 6px 6px var(--button-text-color) !important;
            transition: .25s !important;
            text-transform: uppercase !important;
            font-family: 'Dotties-Vanilla-Bold' !important;
            margin-right: 6px !important;
          }
          button[type="submit"]:hover {
            box-shadow: none !important;
            transform: translate(6px,6px);
          }
        `;
        shadow.appendChild(style);
      });

      // -------------------
      // Shopify Payments Styling
      // -------------------
      document.querySelectorAll('shopify-payment-terms').forEach(payment => {
        const shadow = payment.shadowRoot;
        if (!shadow || shadow._customized) return;

        const style = document.createElement('style');
        style.textContent = `
          .font-system {
            font-family: var(--font-stack-body) !important;
          }
        `;
        shadow.appendChild(style);

        shadow._customized = true;
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  });

  // -------------------
  // External Links to Open in New Tab
  // -------------------
var links = document.links;
for (let i = 0, linksLength = links.length; i < linksLength; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = "_blank";
    links[i].rel = "noreferrer noopener";
  }
}


})();
